import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BuyComponent } from './buy/buy.component';
import { RentComponent } from './rent/rent.component';
import { SellComponent } from './sell/sell.component';
import { AuthGuard } from './auth/auth-guard.service';
import { UserprofileComponent } from './auth/userprofile/userprofile.component';
import { AdminComponent } from './admin/admin/admin.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'buy', component: BuyComponent },
  { path: 'sell', component: SellComponent, canActivate: [AuthGuard] },
  { path: 'rent', component: RentComponent },
  { path: 'profile', component: UserprofileComponent },
  { path: 'siteadmin', component: AdminComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
